var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-style login-page-root",staticStyle:{"margin-top":"-55px"}},[_c('div',{staticClass:"row m-0"},[_c('div',{staticClass:"col-12 p-0"},[_c('FormLogin')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }